let savedConfig = {};

const validate = (values, { t }) => {
  const errors = {};
  ['password', 'passwordConfirmation'].forEach(element => {
    let value = values[element];
    if (
      value === undefined ||
      typeof value !== 'string' ||
      value.trim() === ''
    ) {
      errors[element] = t`register:error.emptyField`;
    }
  });

  if (savedConfig['password_regex_frontend']) {
    let regexp = new RegExp(savedConfig['password_regex_frontend']);
    if (!regexp.test(values.password)) {
      errors.password = savedConfig['password_regex_message'];
    }
  }

  if (
    values.password &&
    values.passwordConfirmation &&
    values.password !== values.passwordConfirmation
  ) {
    errors.passwordConfirmation = t`register:error.passwordsNotEqual`;
  }

  return errors;
};

export default validate;
